import '@/style/index.scss'
import '@/style/custom/main.css'
import '@/style/custom/icon.css'
import '@/style/custom/animation.css'
import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import { routeInterceptor, requestInterceptor, prototypeInterceptor } from './interceptors'
import 'virtual:uno.css'

import router from './router'

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  app.use(router)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  return {
    app,
  }
}
